import React, { Component } from 'react';
import PropTypes from 'prop-types';

const AppContext = React.createContext();

class AppProvider extends Component {
  constructor() {
    super();

    this.state = {
      locations: [], // eslint-disable-line react/no-unused-state
      fish: [], // eslint-disable-line react/no-unused-state
      variables: {}, // eslint-disable-line react/no-unused-state
    };

    this.fetchLocations = this.fetchLocations.bind(this);
    this.fetchFish = this.fetchFish.bind(this);
    this.fetchVariables = this.fetchVariables.bind(this);
  }

  async componentWillMount() {
    await this.fetchLocations();
    await this.fetchFish();
    await this.fetchVariables();
  }

  async fetchLocations() {
    try {
      const res = await fetch('/api/v1/locations.json');
      const locations = await res.json();

      this.setState({
        locations, // eslint-disable-line react/no-unused-state
      });
    } catch (e) {
      console.log(`Error pulling location data: ${e}`); // eslint-disable-line no-console
    }
  }

  async fetchFish() {
    try {
      const res = await fetch('/api/v1/fish.json');
      const fish = await res.json();

      this.setState({
        fish, // eslint-disable-line react/no-unused-state
      });
    } catch (e) {
      console.log(`Error pulling fish data: ${e}`); // eslint-disable-line no-console
    }
  }

  async fetchVariables() {
    try {
      const res = await fetch('/api/v1/variables.json');
      const variables = await res.json();

      this.setState({
        variables, // eslint-disable-line react/no-unused-state
      });
    } catch (e) {
      console.log(`Error pulling variables data: ${e}`); // eslint-disable-line no-console
    }
  }

  render() {
    const { children } = this.props;
    return (
      <AppContext.Provider value={this.state}>
        {children}
      </AppContext.Provider>
    );
  }
}

AppProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export { AppContext, AppProvider };



// WEBPACK FOOTER //
// ./src/Context/AppContext/index.jsx